// extracted by mini-css-extract-plugin
module.exports = {"content":"FinancialAssistance_content__wZpPa","text":"FinancialAssistance_text__2hqi2"};